module.exports = __webpack_public_path__ + "static/img/TAF_Renwu_4.7ea884e1.jpg";